module.exports = __webpack_public_path__ + "img/sushimithintergrund.4bb943e0.jpg";